import pb from '../lib/pocketbase';

export async function getOperadores(page, perPage) {
  return await pb.collection('operador').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: '' // Ajusta si necesitas expandir relaciones
  });
}

export async function createOperador(operador) {
  return await pb.collection('operador').create(operador);
}

export async function updateOperador(id, operador) {
  return await pb.collection('operador').update(id, operador);
}

export async function deleteOperador(id) {
  return await pb.collection('operador').delete(id);
}
